/**
 * Internal dependencies
 */
import SaveShortcut from './save-shortcut';

export default function TextEditorGlobalKeyboardShortcuts() {
	return <SaveShortcut resetBlocksOnSave />;
}
